import Vue from 'vue'
import App from './App'
import VeeValidate from "vee-validate";
import router from './router'
// import axios from './components/common/resouces/http.js'
import {get , post , ajax} from './components/common/resouces/http.js'
import common from './components/common/resouces/common.js'
import VueI18n from 'vue-i18n' 
import Vuex from 'vuex'
import store from './store'
import Message from '@/components/common/message'




Vue.config.productionTip = false

Vue.use(VeeValidate);
Vue.use(VueI18n)

Vue.prototype.$my_message = Message.install;
// Vue.prototype.$ajax = axios

Vue.prototype.$get = get
Vue.prototype.$post = post 
Vue.prototype.$ajax = ajax 




Vue.prototype.bus = new Vue;
Vue.prototype.common = common


let domain = window.location.hostname.split(".");
store.dispatch('getDomain',domain);



store.commit('setLang');



function getlang(){  
    var language = (navigator.browserLanguage || navigator.language).toLowerCase();    
    if(language.indexOf('zh')>-1){
        window.localStorage.setItem('language', 'zh-cn');      
        return 'zh-cn'
    }else{
        window.localStorage.setItem('language', 'en-us');      
        return 'en-us'
    }
}

// function getlang(){
//     let g = navigator.language ||navigator.userLanguage
//     if(g == 'zh-CN' || g == 'zh-cn' || g == 'zh' || g == 'ZH-CN'){
//       g = 'zh-cn'
//     }else{
//       g = 'en-us'
//     }   
//     return g
// }

function lang(){
  let t = window.localStorage.getItem('language')
  if (t) return t
  else return  getlang() 
}

const language = lang() // 自定义window的lang 属性
window.lang = lang()
const i18n = new VueI18n({ 
   locale: language, // 语言标识
   messages: { 
    'zh-cn': require('./components/common/resouces/lang/zh'), 
    'en-us': require('./components/common/resouces/lang/en') 
   } 
}) 





router.beforeEach((to, from, next) => {         
  store.commit('clearToken'); // 取消请求  
  if (to.matched.length === 0 ) {  //如果未匹配到路由    
    if(localStorage.getItem('access_token')){
      if(form.name){
        next({
         name:from.name
        })      
      }else{
         next('/')      
      }
    }else{
      next({
        path:'/login'
      })
    }
    
    // from.name ? next({ name:from.name }) : next('/');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  } else {
    next();    //如果匹配到正确跳转
  }
})


// if(localStorage.getItem('access_token')){
//   from.name ? next({ name:from.name }) : next('/');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由  
// }else{
//   next({
//     path:'/login'
//   })
// }


new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'

})



// WEBPACK FOOTER //
// ./src/main.js